import React from "react";
import { Skeleton, Spin } from "antd";
import { useImageLoader } from "../customHook/ImageLoader";
import noImage from "../../assets/no-image.avif";

const ImageDisplay = ({
  resourceId,
  previewImgResourceId = null,
  imageStyle,
  classNameCss,
  showLoading = "true",
}) => {
  const { imageUrl, loading, error } = useImageLoader(
    previewImgResourceId || resourceId,
  );

  if (loading && showLoading) {
    return (
      <div className={classNameCss} style={imageStyle}>
        <Skeleton.Image active className="w-full" />
      </div>
    );
  }

  if (error) {
    return (
      <img
        className={classNameCss}
        src={noImage}
        style={imageStyle}
        alt="Error loading"
        loading="lazy"
      />
    );
  }

  if (imageUrl) {
    return (
      <img
        className={classNameCss}
        src={imageUrl}
        style={imageStyle}
        alt="Preview"
        loading="lazy"
      />
    );
  }

  return null;
};

export default ImageDisplay;
